import React from "react";
import { FeatureThreeItem } from "./FeatureThreeItem";
import { getServices } from "../../data/services";
import { useTranslation } from "react-i18next";

export const FeatureThree = () => {
  const { t } = useTranslation();
  const services = getServices(t);

  return (
    <section className="features-area-three">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-7">
            <div className="section-title-two text-center mb-40 tg-heading-subheading animation-style1">
              <span className="sub-title tg-element-title">
                {t("home.servicesSubTitle")}
              </span>
              <h2 className="title tg-element-title">
                {t("home.servicesTitle")}
              </h2>
            </div>
          </div>
        </div>

        <div className="features-item-wrap-two">
          <div className="row justify-content-center">
            {services.map((feature) => (
              <div key={feature.id} className="col-xl-3 col-lg-4 col-md-6">
                <FeatureThreeItem feature={feature} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
